module.exports = __webpack_public_path__ + "static/bloomB-branding-logo-v2-f7dcca08e065a038af79ea8ad6ea3be9.png";